module.exports = __webpack_public_path__ + "static/react-native-ba13947eebf8fcc59f0f61a04a5ac923.png";